import React from 'react';
import {
  BackArrowContainer,
  HoverButtonContainer,
  HoverSection,
} from './styled';
import { images } from '../../../Constants/ImageUrls';
import { useIsDesktop } from '../../../Utils/productPageUtils';

function ButtonOnHover(props) {
  const { second, text, count, shiftTop } = props;
  const isDesktop = useIsDesktop();
  // console.log(shiftTop);
  return (
    <HoverSection className="hoverClass">
      <HoverButtonContainer shiftTop={shiftTop} second={second}>
        <p className="category">{text}</p>
        {/* <p className="products">{count} products</p> */}
      </HoverButtonContainer>
      {isDesktop ? (
        <BackArrowContainer second={second}>
          <img src={images?.backArrowCartBlack} alt="" />
        </BackArrowContainer>
      ) : null}
    </HoverSection>
  );
}

export default ButtonOnHover;
